import { render, staticRenderFns } from "./TheSwiper.vue?vue&type=template&id=2470d00d&scoped=true&"
import script from "./TheSwiper.vue?vue&type=script&lang=js&"
export * from "./TheSwiper.vue?vue&type=script&lang=js&"
import style0 from "./TheSwiper.vue?vue&type=style&index=0&id=2470d00d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2470d00d",
  null
  
)

export default component.exports